import { render, staticRenderFns } from "./creditbankManage.vue?vue&type=template&id=bf20d320&"
import script from "./creditbankManage.vue?vue&type=script&lang=js&"
export * from "./creditbankManage.vue?vue&type=script&lang=js&"
import style0 from "./creditbankManage.vue?vue&type=style&index=0&id=bf20d320&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports